export class PrivateLinkFormatInstructions {
    'steps';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "steps",
            "baseName": "steps",
            "type": "Array<PrivateLinkInstructionStep>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PrivateLinkFormatInstructions.attributeTypeMap;
    }
    constructor() {
    }
}
